import { render, staticRenderFns } from "./Bleeding.vue?vue&type=template&id=feb835fc&"
import script from "./Bleeding.vue?vue&type=script&lang=ts&"
export * from "./Bleeding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports